import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';

import { actions, selectors } from 'src/store';
import { paths } from 'src/constants';
import { useIntlMessages } from 'src/hooks';

import { Container } from './components';

const ClimbStepThreeExtraCollections = ({
  climbStepThreeExtraCollections,
  climbStepThreeExtraCurrency,
  getCollections,
  hasLoaded,
  student,
}) => {
  const messages = useIntlMessages();

  return (
    <Container
      className="climb-collections-container--step-three-extra"
      currency={climbStepThreeExtraCurrency}
      getCollections={getCollections}
      hasLoaded={hasLoaded}
      items={climbStepThreeExtraCollections}
      levelsPath={paths.CLIMB_STEP_THREE_EXTRA_LEVELS}
      student={student}
      title={messages.subactivity.climbStepThreeExtra}
    />
  );
};

ClimbStepThreeExtraCollections.propTypes = {
  climbStepThreeExtraCollections: PropTypes.arrayOf(PropTypes.shape({}))
    .isRequired,
  climbStepThreeExtraCurrency: PropTypes.shape({}).isRequired,
  getCollections: PropTypes.func.isRequired,
  hasLoaded: PropTypes.bool.isRequired,
  student: PropTypes.shape({}).isRequired,
};

const mapStateToProps = (state) => ({
  hasLoaded: selectors.climbStepThreeExtraCollections.getHasLoaded(state),
  climbStepThreeExtraCollections: selectors.climbStepThreeExtraCollections.getCollectionsData(
    state
  ),
  climbStepThreeExtraCurrency: selectors.climbStepThreeExtraCollections.getCurrencyData(
    state
  ),
  student: selectors.authentication.getStudent(state),
});

const mapDispatchToProps = {
  ...actions.climbStepThreeExtra,
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  memo
)(ClimbStepThreeExtraCollections);
